export const DEFAULT_WHY_BUY_PLACEHOLDER_LABEL = 'Key Feature';

export const WHY_BUY_PLACEHOLDER_LABELS: Record<string, string> = {
  feature: 'Key Feature',
  grafted_feature: 'Key Feature',
  grafted_option: 'Installed Option',
  grafted_package: 'Installed Package',
  option: 'Installed Option',
  package: 'Installed Package',
  standard: 'Key Feature'
};
